import React from "react"
import RecommendationSection from "./RecommendationSection"


const Recommendations = ({ recommendations, perPage }) => {
  const sections = recommendations.sections.filter(sect => sect.recommendations.length !== 0)
  return (
    <section>
      {sections.map((section, i) => (
        <RecommendationSection
          key={i}
          section={section}
          perPage={perPage}
          featured={i === 0}
        />
      ))}
    </section>
  )
}

export default Recommendations



// WEBPACK FOOTER //
// ./assets/dashboard/components/Recommendations.js